/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getStructDecoder,
  getStructEncoder,
  getU128Decoder,
  getU128Encoder,
  getU64Decoder,
  getU64Encoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type SwapResult2 = {
  includedFeeInputAmount: bigint;
  excludedFeeInputAmount: bigint;
  amountLeft: bigint;
  outputAmount: bigint;
  nextSqrtPrice: bigint;
  tradingFee: bigint;
  protocolFee: bigint;
  partnerFee: bigint;
  referralFee: bigint;
};

export type SwapResult2Args = {
  includedFeeInputAmount: number | bigint;
  excludedFeeInputAmount: number | bigint;
  amountLeft: number | bigint;
  outputAmount: number | bigint;
  nextSqrtPrice: number | bigint;
  tradingFee: number | bigint;
  protocolFee: number | bigint;
  partnerFee: number | bigint;
  referralFee: number | bigint;
};

export function getSwapResult2Encoder(): FixedSizeEncoder<SwapResult2Args> {
  return getStructEncoder([
    ["includedFeeInputAmount", getU64Encoder()],
    ["excludedFeeInputAmount", getU64Encoder()],
    ["amountLeft", getU64Encoder()],
    ["outputAmount", getU64Encoder()],
    ["nextSqrtPrice", getU128Encoder()],
    ["tradingFee", getU64Encoder()],
    ["protocolFee", getU64Encoder()],
    ["partnerFee", getU64Encoder()],
    ["referralFee", getU64Encoder()],
  ]);
}

export function getSwapResult2Decoder(): FixedSizeDecoder<SwapResult2> {
  return getStructDecoder([
    ["includedFeeInputAmount", getU64Decoder()],
    ["excludedFeeInputAmount", getU64Decoder()],
    ["amountLeft", getU64Decoder()],
    ["outputAmount", getU64Decoder()],
    ["nextSqrtPrice", getU128Decoder()],
    ["tradingFee", getU64Decoder()],
    ["protocolFee", getU64Decoder()],
    ["partnerFee", getU64Decoder()],
    ["referralFee", getU64Decoder()],
  ]);
}

export function getSwapResult2Codec(): FixedSizeCodec<
  SwapResult2Args,
  SwapResult2
> {
  return combineCodec(getSwapResult2Encoder(), getSwapResult2Decoder());
}
